import { render, staticRenderFns } from "./Lesson.vue?vue&type=template&id=a05fafce&scoped=true&lang=html"
import script from "./Lesson.vue?vue&type=script&lang=js"
export * from "./Lesson.vue?vue&type=script&lang=js"
import style0 from "./Lesson.vue?vue&type=style&index=0&id=a05fafce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05fafce",
  null
  
)

export default component.exports